import { Flags } from "@/feature-flags";
import { useFlag } from "@/hooks/use-flag";
import { DESKTOP_APP_DOWNLOAD_URL } from "@/desktop";

const OLD_BASE_URL = "https://releases.gitpod.io";
const NEW_BASE_URL = "https://app.gitpod.io/releases";

/**
 * Replaces the base URL in a release URL string.
 * Similar to mutateReleaseURLs in backend/api/runner_interaction.go
 * 
 * @param url - The URL to transform
 * @param useProxy - Whether to use the proxy URL
 * @returns The URL with the appropriate base
 * 
 * @internal Exported for testing
 */
export function replaceBaseUrl(url: string, useProxy: boolean): string {
    if (!useProxy) {
        return url;
    }
    return url.replace(OLD_BASE_URL, NEW_BASE_URL);
}

/**
 * Hook to get the desktop app download URL based on the use_releases_proxy feature flag.
 * Uses the constant from desktop.ts and replaces the base URL when the flag is enabled.
 * 
 * @returns Object containing the desktop download URL and loading state
 */
export function useDesktopDownloadUrl() {
    const { value: useProxy, loading } = useFlag(Flags.UseReleasesProxy, false);

    return {
        url: replaceBaseUrl(DESKTOP_APP_DOWNLOAD_URL, useProxy),
        loading,
    };
}
